import React from "react";
import { useLocation } from "react-router";
import styled from "styled-components";
import content from "../../content";
import { useDesktop } from "../Responsive";

function Done() {
  return (
    <svg
      style={{ marginRight: "10px" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="#231F20" />
      <path d="M6.5 9.5L9.5 13L13.5 7" stroke="white" />
    </svg>
  );
}

function Elipse() {
  return (
    <svg
      style={{ marginRight: "10px" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.3" cx="10" cy="10" r="10" fill="#231F20" />
    </svg>
  );
}

const Label = styled.div`
  font-size: 12px;
  color: #080808;
  opacity: 0.6;
`;

function Step({ label, done, active, noArrow = false }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        boxSizing: "border-box",
        borderBottom: active ? "2px solid #C41230" : "unset",
        height: "52px",
      }}
    >
      {done ? <Done /> : <Elipse />}
      <Label>{label}</Label>
      {!noArrow && (
        <svg
          style={{ margin: "0px 16px 0px 10px" }}
          width="14"
          height="8"
          viewBox="0 0 14 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity="0.3"
            d="M13.3536 4.35355C13.5488 4.15829 13.5488 3.84171 13.3536 3.64645L10.1716 0.464466C9.97631 0.269204 9.65973 0.269204 9.46447 0.464466C9.2692 0.659728 9.2692 0.976311 9.46447 1.17157L12.2929 4L9.46447 6.82843C9.2692 7.02369 9.2692 7.34027 9.46447 7.53553C9.65973 7.7308 9.97631 7.7308 10.1716 7.53553L13.3536 4.35355ZM0 4.5H13V3.5H0V4.5Z"
            fill="#080808"
          />
        </svg>
      )}
    </div>
  );
}

function Stepper({}: IStepper) {
  const location = useLocation();

  const desktop = useDesktop();

  return desktop ? (
    <div style={{ display: "flex", marginLeft: "35px" }}>
      <Step
        active={location.pathname === "/order"}
        done={["/distributor", "/confirmation", "/services"].includes(
          location.pathname
        )}
        label={content.getValue("stepper_step_1")}
      />
      <Step
        active={location.pathname === "/services"}
        done={["/distributor", "/confirmation"].includes(location.pathname)}
        label={content.getValue("stepper_step_2")}
      />
      <Step
        noArrow={true}
        active={location.pathname === "/distributor"}
        done={["/confirmation"].includes(location.pathname)}
        label={content.getValue("stepper_step_3")}
      />
    </div>
  ) : (
    <></>
  );
}

export interface IStepper {}

export default Stepper;
